import {
  FIND_GLOBAL_FORMS_USE_CASE,
  IGlobalFormRepository,
  GLOBAL_FORM_REPOSITORY,
  FindGlobalFormsQueryUseCase,
  GetGroupGlobalFormByCategoryQueryUseCase,
  GET_GROUP_GLOBAL_FORM_BY_CATEGORY_USE_CASE,
} from '@module/form';

export const globalFormUseCaseProviders = [
  {
    provide: FIND_GLOBAL_FORMS_USE_CASE,
    useFactory: (globalFormRepository: IGlobalFormRepository) => {
      return new FindGlobalFormsQueryUseCase(globalFormRepository);
    },
    inject: [GLOBAL_FORM_REPOSITORY],
  },
  {
    provide: GET_GROUP_GLOBAL_FORM_BY_CATEGORY_USE_CASE,
    useFactory: (globalFormRepository: IGlobalFormRepository) => {
      return new GetGroupGlobalFormByCategoryQueryUseCase(globalFormRepository);
    },
    inject: [GLOBAL_FORM_REPOSITORY],
  },
];
